import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import AuditMd from "@md/Audits.md";
import { useAppContext } from "@context/AppContext";

const Audits = () => {
  const [md, setMD] = useState({});
  const { themeConfig } = useAppContext();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  useEffect(() => {
    let text = AuditMd;
    text = text.replace(
      new RegExp("{__beneficiary__}", "g"),
      themeConfig.APP_BENEFICIARY
    );
    text = text.replace(
      new RegExp("{__artist__}", "g"),
      themeConfig.APP_ARTIST
    );
    text = text.replace(
      new RegExp("{__fundraiser__}", "g"),
      themeConfig.APP_SPONSOR
    );
    setMD(text);
  }, [themeConfig]);

  return (
    <section id="audits" className="page-settings">
      <h1 className="audits__title title-styles-nocaptial">Audits</h1>
      <div className="faqs__qas-box">
        <div className="faqs__md">
          <ReactMarkdown>{md}</ReactMarkdown>
        </div>
      </div>
    </section>
  );
};

export default Audits;
